import { getContentLang } from 'core/utils/contentLang';
import { htmlToText } from 'core/utils/htmlToText';

type ViewerContent = { name?: string | null } | null | undefined;
type ViewerCourse = Parameters<typeof getContentLang>[0];
type ViewerPageHeading = { pageHeading: string; pageHeadingLang: string | undefined };

/** Nombre del recurso que el visor informa en `onContentLoaded`, en texto plano como el título de la pestaña; vacío si no lo informa. */
export function getViewerContentName(content: ViewerContent): string {
  return htmlToText(content?.name);
}

/**
 * Encabezado del visor a pantalla completa (TAN-10967): el nombre del recurso, en el idioma del programa, o
 * «Visor» en el de la interfaz mientras el visor no lo informa. Lo comparten los `useViewer` de app y Edelvives.
 */
export function getViewerPageHeading(contentName: string, course: ViewerCourse, t: (key: string) => string): ViewerPageHeading {
  if (!contentName) return { pageHeading: t('titles:Viewer'), pageHeadingLang: undefined };
  return { pageHeading: contentName, pageHeadingLang: getContentLang(course) };
}
